import type { CosignatureStatus } from "../../types/cosignature";
import { CosignatureStatusEnum } from "../../constants";

const KNOWN_COSIGNATURE_STATUSES: string[] = Object.values(CosignatureStatusEnum);

export function isCosignatureStatus(value: unknown): value is CosignatureStatus {
  return typeof value === "string" && KNOWN_COSIGNATURE_STATUSES.includes(value);
}
